import React from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from "../navbar";
import Hero from "./Hero.jsx"
import FeaturedCategories from "./FeaturedCategories.jsx"
import ValueProposition from "./ValueProposition";
import AboutSection from "./AboutSection";
import BestsellerProducts from "./BestsellerProducts";
import Footer from "../footer";
import { Helmet } from "react-helmet";
import ProductCategoriesGrid from "./ProductCategoriesGrid.jsx";
import {basket, bowl , lBags , matka} from "./filtered.js"
import ItemCrousel from "../home_components/ItemCrousel.js"

const Index = () => {

  const [size, setSize] = React.useState('largest');

  React.useEffect(() => {
      // Initialize AOS
      AOS.init({
          duration: 800,
          easing: 'ease-in-out',
          once: true,
          offset: 100,
          delay: 100
      });

      const handleResize = () => {
          setSize(window.innerWidth < 768 ? 'smaller' : 'largest');
      };

      handleResize();
      window.addEventListener('resize', handleResize);

      return () => {
          window.removeEventListener('resize', handleResize);
          AOS.refresh(); // Clean up AOS
      };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
          <title>Jutexx | Handcrafted Jute Baskets, Bowls & Bags</title>
          <meta 
              name="description" 
              content="Shop handcrafted jute products including eco-friendly baskets, bowls, and storage bags made in India. Perfect for home décor and sustainable living." 
          />
          <meta 
              name="keywords" 
              content="jutexx, jute baskets, eco-friendly home decor, handmade jute, sustainable products, jute bowls, storage bags" 
          />
          <script type="application/ld+json">
              {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Product",
              "name": "Handcrafted Jute Products",
              "image": "https://cdn-icons-png.flaticon.com/512/9326/9326476.png",
              "description": "Explore beautifully handcrafted jute baskets, bowls, and storage bags from Jutexx—sustainable and made in India.",
              "brand": {
                  "@type": "Brand",
                  "name": "Jutexx"
              }
              })}
          </script>
      </Helmet>
      <Navbar />
      <main className="flex-1">
        <div data-aos="fade-in">
          <Hero />
        </div>
        
        <div data-aos="fade-up" data-aos-delay="200">
          <BestsellerProducts />
        </div>

        <div className="flex items-center justify-center py-4" data-aos="fade-left" data-aos-delay="300">
          <div className="overflow-hidden max-w-[1400px] px-2 sm:p-0">
              <ItemCrousel
                  data={bowl}
                  label={"Explore our Trending Bowls"}
                  size={size}
              />
          </div>
        </div>

        <div data-aos="fade-left" data-aos-delay="400">
          <ValueProposition />
        </div>
        
        <div data-aos="fade-right" data-aos-delay="500">
          <AboutSection />
        </div>

        <div className="flex items-center justify-center py-4" data-aos="fade-up" data-aos-delay="600">
          <div className="overflow-hidden max-w-[1400px] px-2 sm:p-0">
              <ItemCrousel
                  data={lBags}
                  label={"Explore our Trending Laundry Bags"}
                  size={size}
              />
          </div>
        </div>

        <div data-aos="fade-up" data-aos-delay="700">
          <ProductCategoriesGrid/>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;